
import { mapGetters, mapMutations } from 'vuex';
import vClickOutside from 'v-click-outside';
import FavoritesClearIcon from '@/components/svg/FavoritesClearIcon.vue';
import ProfileFilledIcon from '@/components/svg/ProfileFilledIcon.vue';
import CartIcon from '@/components/svg/CartIcon.vue';
import CompareIcon from '@/components/svg/CompareIcon.vue';
import LanguageSwitch from '@/components/header/LanguageSwitch.vue';
import HeaderNavigationMixin from '~/mixins/HeaderNavigationMixin';

export default {
    name: 'MenuMobileCasa',
    mixins: [HeaderNavigationMixin],
    components: { LanguageSwitch, CompareIcon, CartIcon, ProfileFilledIcon, FavoritesClearIcon },
    data() {
        return {
            isShow: false,
            userTheme: 'light-theme',
            userThemeState: this.userTheme === 'light-theme'
        };
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            getShowNavigationMobile: 'getShowNavigationMobile',
            getMenu: 'getMenu',
            mainPhoneNumber: 'global/mainPhoneNumber',
            isCasaDelTabaco: 'global/getIsCasaDelTabaco',
            isUniPlast: 'global/getIsUniPlast',
            getCurrentTheme: 'global/getCurrentTheme',
            isAuth: 'auth/isAuth'
        })
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    methods: {
        ...mapMutations(['setShowMenuMobile', 'setShowNavigationMobile']),
        async triggerAuthBtn() {
            if (this.isAuth) {
                await this.$router.push({ path: this.localePath('/account') });
            } else {
                await this.$store.dispatch('setShowAuth', true);
            }
            this.setShowNavigationMobile(false);
        },
        closeMenuMobile() {
            this.setShowNavigationMobile(false);
        },
        forceRepaint() {
            document.body.style.display = 'none';
            document.body.offsetHeight;
            document.body.style.display = '';
        },
        getTheme() {
            const savedTheme = this.$cookies.get('user-theme');

            const isDarkTheme = document.body.classList.contains('dark-theme');
            const isLightTheme = document.body.classList.contains('light-theme');

            if (savedTheme) {
                return savedTheme;
            } else {
                if (isDarkTheme) {
                    return 'dark-theme';
                } else if (isLightTheme) {
                    return 'light-theme';
                } else {
                    return null;
                }
            }
        },
        setTheme(name) {
            this.userTheme = name;

            if (name === 'light-theme') {
                document.body.classList.remove('dark-theme');
                document.body.classList.add('light-theme');
                this.$cookies.set('user-theme', 'light-theme');
                this.$store.dispatch('global/setTheme', 'light-theme');
            } else if (name === 'dark-theme') {
                document.body.classList.remove('light-theme');
                document.body.classList.add('dark-theme');
                this.$cookies.set('user-theme', 'dark-theme');
                this.$store.dispatch('global/setTheme', 'dark-theme');
            }

            this.forceRepaint();
        },
        toggleTheme() {
            const activeTheme = this.$cookies.get('user-theme');
            const newTheme = activeTheme === 'light-theme' ? 'dark-theme' : 'light-theme';

            this.setTheme(newTheme);
        }
    },
    mounted() {
        const initUserTheme = this.getTheme() || this.getMainTheme?.replace(/_/, '-');
        this.setTheme(initUserTheme);
    }
};
